export const IGNORE_PROP = 'data-prevent-format';
